import React from "react";
import { useState } from "react";

function Square({value, onSquareClick}) {
  return (
  <button className="square" onClick={onSquareClick}>
    {value}
    </button>
  )
}


function calculateWinner(squares) {
  const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
  for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c]) {
      return squares[a];
    }
  }
  return null;
}

export default function App() {
  const [xIsNext, setXIsNext] = useState(true);
  const [turns, setTurns] = useState(0);
  const [squares, setSquares] = useState(Array(9).fill(null));
  
  const winner = calculateWinner(squares);
  let status;
  if (winner) {
    status = 'Winner: ' + winner;
  } else {
    status = 'Next player: ' + (xIsNext ? 'X' : 'O');
  }
  
  function handleClick(i, turns) {
  if (calculateWinner(squares) || squares[i]) {return}
  else if (turns===0) {turn0(squares, i)}
  else if (turns===2) {turn2(squares, i)}
  else {
    setSquares(squares => {
      const newSquares = [...squares];
      if(turns % 2 === 0){
        newSquares[i] = 'X';
      }
      else{
        newSquares[i] = 'O';
      }
      setTurns(turns + 1);
      
      return newSquares;
    })
    
  }
  function turn0(squares, i) {
    const corners = [0, 2, 6, 8];
    if (corners.includes(i)) {
      alert("good choice!");
      setSquares(squares => {
        const newSquares = [...squares];
        if(xIsNext){
          newSquares[i] = 'X';
        }
        else{
          newSquares[i] = 'O';
        }
        setTurns(turns + 1);
        return newSquares;
      })
    }
    else{
      alert("good choice!");
      setSquares(squares => {
        const newSquares = [...squares];
        newSquares[i] = 'X';
        setTurns(turns + 1);
        return newSquares;
      })
    }
  }
  function turn2(squares, i) {
    //if o is center pick square diagonal to x
    if(squares[4]==='O'){
      if((squares[0]==='X'&&!(i===8))||(squares[2]==='X'&&!(i===6))||(squares[6]==='X'&&!(i===2))||(squares[8]==='X'&&!(i===0))){
        alert("Not a good choice!");
        return
      }
    }
    //if o is not center X must place its next X in a corner with a blank space between it and its first X. However, the blank space cannot be the center square. 
    else if(squares[0]=='X'){ //for x in top left
      if(squares[1]=='O'&&!(i===6)){
        alert("Not a good choice!");
        return
      }
      else if(squares[3]=='O'&&!(i===2)){
        alert("Not a good choice!");
        return
      }
      else if (!(i===2||i===6||i===8)){
        alert("Not a good choice!");
        return
      }
    }
    else if(squares[2]=='X'){ //for x in top right
      if(squares[1]=='O'&&!(i===8)){
        alert("Not a good choice!");
        return
      }
      else if(squares[5]=='O'&&!(i===0)){
        alert("Not a good choice!");
        return
      }
      else if (!(i===0||i===8||i===6)){
        alert("Not a good choice!");
        return
      }
    }
    else if(squares[6]=='X'){ //for x in bottom left
      if(squares[7]=='O'&&!(i===0)){
        alert("Not a good choice!");
        return
      }
      else if(squares[3]=='O'&&!(i===8)){
        alert("Not a good choice!");
        return
      }
      else if (!(i===0||i===8||i===2)){
        alert("Not a good choice!");
        return
      }
    }
    else if(squares[8]=='X'){ //for x in bottom right
      if(squares[5]=='O'&&!(i===6)){
        alert("Not a good choice!");
        return
      }
      else if(squares[7]=='O'&&!(i===2)){
        alert("Not a good choice!");
        return
      }
      else if (!(i===2||i===6||i===0)){
        alert("Not a good choice!");
        return
      }
    }
    alert("good choice!");
    setSquares(squares => {
      const newSquares = [...squares];
      newSquares[i] = 'X';
      setTurns(turns + 1);
      return newSquares;
    })
  }
  }
  
  return (
  <div className="App">
    <div className="game-board">
      <h1>Tic Tac Toe</h1>
    <div className="status">{status}</div>
    <div className="turns">{turns}</div>
    <div className="board-row">
      <Square value={squares[0]} onSquareClick={() => handleClick(0, turns)} />
      <Square value={squares[1]} onSquareClick={() => handleClick(1, turns)} />
      <Square value={squares[2]} onSquareClick={() => handleClick(2, turns)} />
      </div>
    <div className="board-row">
      <Square value={squares[3]} onSquareClick={() => handleClick(3, turns)} />
      <Square value={squares[4]} onSquareClick={() => handleClick(4, turns)} />
      <Square value={squares[5]} onSquareClick={() => handleClick(5, turns)} />
      </div>
    <div className="board-row">
      <Square value={squares[6]} onSquareClick={() => handleClick(6, turns)} />
      <Square value={squares[7]} onSquareClick={() => handleClick(7, turns)} />
      <Square value={squares[8]} onSquareClick={() => handleClick(8, turns)} />
      </div>
  </div>
  </div>
  );
}

